/* eslint-disable */
import { useRef, useMemo } from "react"; // useRef is used to access the editor instance.
import JoditEditor from "jodit-react"; // JoditEditor is the editor component.

import { uploadSingleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";

const JoditEditorField = ({
  label,
  value,
  onChange,
  labelClassName = "",
  editorHeight = null,
}) => {
  const token = localStorage.getItem("token"); // token

  // Editor configuration with afterPaste event
  const editorConfig = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
      minHeight: editorHeight || 300,
      toolbarSticky: false,
      uploader: { insertImageAsBase64URI: false },
      defaultActionOnPaste: "insert_as_html",
      defaultLineHeight: 1.5,
      enter: "div",
      statusbar: false,
      sizeLG: 900,
      sizeMD: 700,
      sizeSM: 400,
      toolbarAdaptive: false,
      disablePlugins: [
        "image",
        "video",
        "about",
        "classSpan",
        "file",
        "speechRecognize",
        "copyformat",
        "spellcheck",
        "add-new-line",
      ],
      events: {
        afterPaste: async (event) => {
          const clipboardData = event.clipboardData || window.clipboardData;
          const items = clipboardData.items;

          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
              const file = items[i].getAsFile();
              if (!file) continue;

              // Rename file with timestamp
              const timestamp = Date.now();
              const fileExtension = file.type.split("/")[1];
              const newFileName = `image-${timestamp}.${fileExtension}`;
              const renamedFile = new File([file], newFileName, {
                type: file.type,
              });

              try {
                // Upload the pasted image
                const requestUrl = `${url.API_BASE_URL}${url.API_SINGLE_FILE_UPLOAD}?token=${token}`;
                const response = await uploadSingleFile(
                  requestUrl,
                  renamedFile
                );

                if (response.status) {
                  const imageUrl = url.SERVER_URL + response.data.path;
                  const editorInstance = event.target;
                  const content = editorInstance.value;

                  // Replace base64 images with server URLs
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // Update editor content
                  editorInstance.value = newContent;
                  editorInstance.events.fire("change", newContent);
                }
              } catch (error) {
                console.error("Image upload failed:", error);
              }
            }
          }
        },
      },
    }),
    [token]
  );

  return (
    <div className="form-group mb-4">
      <label className={labelClassName}>{label}</label>
      <JoditEditor
        ref={useRef(null)} // useRef is used to access the editor instance.
        value={value}
        config={editorConfig}
        onBlur={onChange}
      />
    </div>
  );
};

export default JoditEditorField;
